export default __webpack_public_path__ + "static/media/team1.80e419dc.jpg";